import { render, staticRenderFns } from "./EventRecord.vue?vue&type=template&id=14daedff&scoped=true&"
import script from "./EventRecord.vue?vue&type=script&lang=js&"
export * from "./EventRecord.vue?vue&type=script&lang=js&"
import style0 from "./EventRecord.vue?vue&type=style&index=0&id=14daedff&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14daedff",
  null
  
)

export default component.exports